import React, { PureComponent } from 'react';
import _ from 'lodash';
import { Icon } from 'antd';
import Input from 'antd/lib/input';
import Collapse, { Panel } from 'antd/lib/collapse';
import Tabs, { TabPane } from 'antd/lib/tabs';
import s from './style.less';
import BookingTable from './components/BookingsTable';
import { bookingTabs } from './config';
import NavBar from '../../components/NavBar';

class App extends PureComponent {
  state = {
    bookings: [],
    page: 1,
    perPage: 10,
    total: 0,
    contract: '',
    provider: '',
    vrn: '',
    customer: '',
  };

  componentDidMount() {
    this.getBookings([1, 2, 3, 4, 5, 6])();
  }

  getBookings = id => async () => {
    const { contract, provider, customer, vrn } = this.state;
    const bookings = await fetch('/admin/bookings-list', {
      method: 'post',
      body: {
        skip: (this.state.page - 1) * this.state.perPage,
        limit: this.state.perPage,
        id,
        contract,
        provider,
        customer,
        vrn,
      },
      credentials: 'include',
    });
    this.setState({
      bookings,
      id,
    });
    this.getPageCount();
  };

  getPageCount = async () => {
    const { id, contract, provider, customer, vrn } = this.state;
    const req = await fetch('/admin/bookings-count', {
      method: 'post',
      body: {
        id,
        contract,
        provider,
        customer,
        vrn,
      },
      credentials: 'include',
    });
    this.setState({
      total: req.result,
    });
  };

  setSearch = key => val => {
    this.setState(
      {
        [key]: val,
        page: 1,
      },
      this.getBookings(this.state.id),
    );
  };

  changeStatus = async (id, status) => {
    await fetch('/admin/set-booking-status', {
      method: 'post',
      body: {
        id,
        status,
      },
      credentials: 'include',
    });
    this.getBookings(this.state.id)();
  };

  searchItems = [
    { key: 'contract', text: 'contract number' },
    { key: 'provider', text: 'provider name' },
    { key: 'vrn', text: 'car registration' },
    { key: 'customer', text: 'customer last name' },
  ];

  clearSearch = key => () => {
    this.setSearch(key)('');
  };

  changePerPage = (current, size) => {
    this.setState({ perPage: size, page: 1 }, this.getBookings(this.state.id));
  };

  changePage = page => {
    this.setState({ page }, this.getBookings(this.state.id));
  };

  changeTab = key => {
    this.setState(
      { bookings: [], page: 1 },
      this.getBookings(_.find(bookingTabs, ['name', key]).id),
    );
  };

  render() {
    return (
      <NavBar withPadding>
        <div className="row">
          <div className={`${s.root} col-md-12`}>
            <div className={s.table}>
              <Collapse bordered={false}>
                <Panel header="Open search" key="1">
                  <div className={s.searchContainer}>
                    {this.searchItems.map(x => (
                      <div key={x.key} className={s.search}>
                        <Input
                          onChange={e => {
                            this.setSearch(x.key)(e.target.value);
                          }}
                          name={x.key}
                          value={this.state[x.key]}
                          placeholder={x.text}
                          suffix={
                            this.state[x.key] ? (
                              <Icon
                                type="close-circle"
                                onClick={this.clearSearch(x.key)}
                              />
                            ) : null
                          }
                        />
                      </div>
                    ))}
                  </div>
                </Panel>
              </Collapse>
            </div>
            <Tabs onChange={this.changeTab}>
              {bookingTabs.map(tab => (
                <TabPane tab={tab.name} key={tab.name}>
                  <BookingTable
                    rows={this.state.bookings}
                    pageSize={+this.state.perPage}
                    current={this.state.page}
                    total={this.state.total}
                    refresh={this.getBookings(this.state.id)}
                    onPageChange={this.changePage}
                    onPageSizeChange={this.changePerPage}
                    onStatusChange={this.changeStatus}
                  />
                </TabPane>
              ))}
            </Tabs>
          </div>
        </div>
      </NavBar>
    );
  }
}

export default App;
